module.exports = __webpack_public_path__ + "static/media/company.5cadf9a7.svg";